import { faTimes as lightTimes } from "@jewlr/pro-light-svg-icons/faTimes"
import Box from "@jewlr/storybook/core/box"
import Button from "@jewlr/storybook/core/button"
import FontAwesomeIcon from "@jewlr/storybook/core/font-awesome-icon"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useState, useCallback } from "react"
import styled from "styled-components"

import Modal, { closeModal } from "components/modal"
import { retry } from "helpers/application"
import withAuth from "hoc/account/with-auth"

const Login = loadable(() => retry(() => import("./login")))
const Register = loadable(() => retry(() => import("./register")))

const Wrapper = styled(Box).attrs({
  height: "100%",
  m: { _: "-16px -16px 0", tablet: "-16px -24px -32px" },
})``

const CloseButton = styled(Button).attrs({
  variant: "text",
})`
  position: absolute;
  right: 16px;
  top: 16px;
  width: 28px;
`
const CloseIcon = styled(FontAwesomeIcon).attrs({
  color: "black",
  fontSize: "1.7em",
  height: "24px",
})``

const Authenticate = ({ resetNotification }) => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })
  const [modalContent, setModalContent] = useState("#authenticate")

  return (
    <Modal
      afterShow={afterShow}
      contentIndex={modalContent === "#signup" ? 0 : 1}
      contentStyle={{
        bg: "white",
      }}
      headerHTML={
        <CloseButton
          aria-label="Close"
          onClick={() => {
            closeModal()
            resetNotification()
          }}
        >
          <CloseIcon icon={lightTimes} />
        </CloseButton>
      }
      modalType="slideup"
      onBack={() => setModalContent("#authenticate")}
      onClose={() => {
        closeModal()
        resetNotification()
      }}
      setModalContent={setModalContent}
      show={["#authenticate", "#signup"]}
    >
      {showContent && (
        <Wrapper>
          {modalContent === "#signup" && (
            <Register setModalContent={setModalContent} />
          )}
          {modalContent === "#authenticate" && (
            <Login setModalContent={setModalContent} />
          )}
        </Wrapper>
      )}
    </Modal>
  )
}

Authenticate.propTypes = {
  resetNotification: PropTypes.func,
}

export default withAuth(Authenticate)
